import type { Meta, StoryObj } from "@storybook/react";

import type { SensitiveDetailsActionBarProps } from "@/ui/components/groupClasses/series/details/ActionBars";
import { SensitiveDetailsActionBar } from "@/ui/components/groupClasses/series/details/ActionBars";

const StoryMeta: Meta<SensitiveDetailsActionBarProps> = {
  title: "Components/Group Classes/Sensitive Details Action Bars",
  component: SensitiveDetailsActionBar,
  argTypes: {
    isAppUserSupport: { control: "boolean" },
    isSensitive: { control: "boolean" },
  },
  args: {
    isAppUserSupport: false,
    isSensitive: true,
  },
};

type Story = StoryObj<SensitiveDetailsActionBarProps>;

const ForPatient: Story = {
  args: {
    isAppUserSupport: false,
    isSensitive: true,
  },
};

const ForUserProxy: Story = {
  args: {
    isAppUserSupport: true,
    isSensitive: true,
  },
};

export { ForPatient, ForUserProxy };
export default StoryMeta;
